import { createSlice } from '@reduxjs/toolkit';
import iframeState from '../../../constants/app/iframeState';

// Create an iframe slice
const IframeSlice = createSlice({
  name: 'iframe',
  initialState: {
    iframeData: iframeState, // Initial iframe data
    isIframeLoaded: false, // Initial iframe loaded state
    isShouldIframeTakeSS: false,
    iframeSS: '',
    iframeUniqueId: '',
  },
  reducers: {
    // Reducer to set flip card data in iframeData
    setIframeFlipcardData: (state, action) => {
      state.iframeData.flipCard = action.payload;
    },

    // Reducer to set previous configuration in iframeData
    setPrevConfig: (state, action) => {
      state.iframeData.config = action.payload;
    },

    // Reducer to set the loaded state of the iframe
    setIsIframeLoaded: (state, action) => {
      state.isIframeLoaded = action.payload;
    },
    setIsShouldIframeTakeSS: (state, action) => {
      state.isShouldIframeTakeSS = action.payload;
    },
    setIframeSS: (state, action) => {
      state.iframeSS = action.payload;
    },
    setIframeUniqueId: (state, action) => {
      state.iframeUniqueId = action.payload;
    },
    setIframePublisher: (state, action) => {
      state.iframeData.flipCard.publisher = action.payload;
    },
    setIframeLanguage: (state, action) => {
      state.iframeData.flipCard.theme.language = action.payload;
    },
  },
});

// Export actions generated by the slice
export const {
  setIframeFlipcardData,
  setPrevConfig,
  setIsIframeLoaded,
  setIsShouldIframeTakeSS,
  setIframeSS,
  setIframeUniqueId,
  setIframePublisher,
  setIframeLanguage,
} = IframeSlice.actions;

// Export the reducer for use in the Redux store
export default IframeSlice.reducer;
